import { useSelector } from 'react-redux';

export const getViewType = (): types.redux.settings.viewType => {
	return useSelector((state: types.redux.IState) => state.settings.viewType);
};
